export default __webpack_public_path__ + "static/media/fossil4.18e3eec8.png";